import React,{useContext, useEffect} from "react";
import {ContextProvider} from "../App"

// import from react-router-dom for routing
import { Switch, Route } from "react-router-dom";

// import modules
import HomeIndex from "../pages/home/HomeIndex.jsx";
import Categories from "../pages/foodCategories/Categories.jsx";
import OrderIndex from "../pages/order/OrderIndex.jsx";
import OrderSummery from "../pages/order/OrderSummery";
import OrderSummeryDetails from "../pages/order/OrderSummeryDetails";


function Router() {
   const {authDispatch} = useContext(ContextProvider)
  
  useEffect(() => {
    const data = JSON.parse(localStorage.getItem('userData'))
    if (data) {
      authDispatch({ type: "Logged_In_User", payload: data })
    }
  },[])
 

  return (
    <>
      <Switch>
        <Route exact path="/" component={HomeIndex} />
        <Route path="/food/categories" component={Categories} />
        <Route path="/food/order/selections-plan" component={OrderIndex} />
        <Route exact path="/food/order-summery" component={OrderSummery} />
        <Route path="/food/order-summery/:id" component={OrderSummeryDetails} />
      </Switch>
    </>
  );
}

export default Router;
